<template>
  <div class="center">
    <div class="step" v-for="(item, index) in vs" :key="index">
      <div class="round">
        <div class="fontS" style="font-size: 20px">{{ item.ts[1] }}月</div>
        <div class="fontS" style="font-size: 36px">{{ item.ts[2] }}</div>
        <div class="fontS" style="font-size: 20px">{{ item.ts[0] }}</div>
      </div>
      <div class="line" v-if="index!=vs.length-1"></div>
      <div class="vs">{{ item.version }}</div>
      <div class="min_s" v-for="(ls, idx) in item.features" :key="idx">
        <div class="min_t">{{ ls.title }}</div>
        <div class="min_m" v-for="(ms, i) in ls.items.split('<br>')" :key="i">{{ ms }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { 
  // get_list_update,
 versionList } from '@/api/system'
export default {
  data() {
    return {
      vs: [],
    }
  },
  activated() {},
  watch: {},
  created() {
       versionList({
        type: 1
      }).then((res) => {
      res.data.forEach(item => {
          Object.assign(item, {
          features: []
        })
         item.features.push(
          {
          items: item.items,
          title: item.title
         }
         ) 
         item['ts'] = item.date.split('-')
          item.features[0].items = item.features[0].items.replace(/\n/g,"<br>");
      })
        this.vs = res.data
        console.log(this.vs, 'this.vs======================')
      })

    // get_list_update().then((res) => {
    //   var lis = res.data
    //   lis.forEach((element) => {
    //     element['ts'] = element.date.split('-')
    //   })
    //   this.vs = res.data
    // })
  },
  mounted() {},
  methods: {},
}
</script>
<style lang='less' scoped>
.center {
  width: 60%;
  height: 100vh;
  overflow-y: scroll;
  margin-left: 50%;
  padding: 30px 20px 20px 20px;
  box-sizing: border-box;
  transform: translateX(-50%);
  font-family: '微软雅黑';
  &::-webkit-scrollbar {
    display: none;
  }
  .step {
    width: 100%;
    float: left;
    padding-left: 190px;
    box-sizing: border-box;
    position: relative;
    .line {
      width: 3px;
      height: 100%;
      background: #2cb1ff;
      float: left;
      position: absolute;
      left: 50px;
    }
    .round {
      position: absolute;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      overflow: hidden;
      background: #2cb1ff;
      left: 10px;
      top: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      color: #fff;
      z-index: 2;
      .fontS {
        line-height: 20px;
      }
    }
    .vs {
      width: 100%;
      font-size: 18px;
      font-weight: 600;
    }
    .min_s {
      width: 100%;
      float: left;
      padding-bottom: 13px;
      min-height: 100px;
      .min_t {
        width: 100%;
        float: left;
        color: #111;
        font-weight: 600;
        font-size: 16px;
      }
      .min_m {
        width: 100%;
        float: left;
        margin-top: 4px;
      }
    }
  }
}
</style>
